import { ProgrammeFilterType } from "@studyportals/search-api-interface";
import { FilterType } from "../enums";

export const PROGRAMME_FILTER_TO_FILTER_TYPE = new Map<ProgrammeFilterType, FilterType>([
	[ProgrammeFilterType.DENSITIES, FilterType.DENSITIES],
	[ProgrammeFilterType.ATTENDANCES, FilterType.ATTENDANCE],
	[ProgrammeFilterType.DISCIPLINES, FilterType.DISCIPLINES],
	[ProgrammeFilterType.AREA_IDS, FilterType.AREA],
	[ProgrammeFilterType.COUNTRY_ISO_CODES, FilterType.COUNTRY],
	[ProgrammeFilterType.DURATIONS, FilterType.DURATION],
	[ProgrammeFilterType.DEGREE_TYPES, FilterType.DEGREE_TYPE],
	[ProgrammeFilterType.EDUCATIONAL_LEVELS, FilterType.EDUCATION_LEVEL],
	[ProgrammeFilterType.EDUCATIONAL_FORMS, FilterType.EDUCATIONAL_FORM],
	[ProgrammeFilterType.TEXT, FilterType.KEYWORD],
	[ProgrammeFilterType.REGION_IDS, FilterType.CONTINENT],
	[ProgrammeFilterType.ORGANISATION_IDS, FilterType.ORGANISATIONS],
	[ProgrammeFilterType.SPECIAL_PROGRAMMES, FilterType.SPECIAL_PROGRAMMES],
]);